import React from "react"
import Dialog from "../dialog/Dialog"
import Card from "../card/Card"
import Button from "../button/Button"
import Icon from "../icon/Icon"
import * as classNames from "./ReviewDialog.module.scss"

const ReviewDialog = ({
  selectedReview,
  selectedReviewIndex,
  setSelectedReviewIndex,
  title,
}) => {
  function generateStars(numStars) {
    const starElements = []
    for (let i = 0; i < numStars; i++) {
      starElements.push(
        <Icon
          key={i}
          icon="star"
          color="#F6B34F"
        />
      )
    }
    return starElements
  }
  return (
    <Dialog className={`${classNames.dialogStyle}`}>
      <div className="">
        <div className="text-center pt-4 relative z-1">
          <h2 className="m-0 ternary-text-color">{title}</h2>
        </div>
      </div>
      <div className="dialog_main">
        <div className={`p-6 relative z-1 ${classNames.contentCard}`}>
          <Button
            aspect="unstyled"
            className="fs-16 ternary-text-color"
            onClick={(e) => {
              setSelectedReviewIndex(selectedReviewIndex - 1)
            }}
          >
            <Icon icon="arrowLeft" />
          </Button>

          <Card className="p-3 mt-2">
            <div className="card__header ">
              <div className="card__header__title mb-1 text-center">
                {generateStars(selectedReview?.attributes?.stars)}
                <br />
                <h5>
                  <strong>{selectedReview?.attributes?.title}</strong>
                </h5>
              </div>
            </div>
            <div className="card__content text-center">
              <p className={`${classNames.description}`}>
                {selectedReview?.attributes?.text}
              </p>
            </div>
            <div
              className={`card__footer mt-auto center ${classNames.footerStyle}`}
            >
              {selectedReview?.attributes?.author
                ? selectedReview?.attributes?.author
                : selectedReview?.attributes?.consumerName}
            </div>
          </Card>

          <Button
            aspect="unstyled"
            className="fs-16 ternary-text-color"
            onClick={(e) => {
              setSelectedReviewIndex(selectedReviewIndex + 1)
            }}
          >
            <Icon icon="arrowRight" />
          </Button>

          <div></div>
        </div>
      </div>
    </Dialog>
  )
}

export default ReviewDialog
